import { createStructuredSelector } from 'reselect';
import * as AppSelectors from 'containers/App/selectors';
import * as CommonSelectors from 'containers/Common/selectors';
import * as DocumentsSelectors from 'containers/Documents/selectors';
import * as LayoutsSelectors from 'containers/Layouts/selectors';
import * as ProjectSelectors from 'containers/Project/selectors';
import { isScreenSwitching } from 'containers/Project/selectors';
import * as RelationsSelectors from 'containers/Relations/selectors';
import * as ScreenDefinitionsSelectors from 'containers/ScreenDefinitions/selectors';

type Props = {
  groupLayoutId?: string;
  layoutId?: string;
};

export const artboardLayoutSelector = ({ groupLayoutId, layoutId }: Props): ReturnType<typeof createStructuredSelector> => createStructuredSelector({
  activeLayoutIds: AppSelectors.activeLayoutIds,
  documents: DocumentsSelectors.documents,
  flatColorsByLayoutId: CommonSelectors.flatColorsByLayoutId,
  isGroupLayoutBeingUploaded: LayoutsSelectors.isLayoutBeingUploaded(groupLayoutId),
  isLayoutBeingUploaded: LayoutsSelectors.isLayoutBeingUploaded(layoutId),
  isOpenToolbar: ProjectSelectors.isOpenToolbar,
  projectType: ProjectSelectors.projectType,
  sectionsWidth: ScreenDefinitionsSelectors.sectionsWidthByName,
  relationsByRegularLayoutId: RelationsSelectors.relationsByRegularLayoutId,
  isPreviewShown: AppSelectors.showPreview,
  isScreenSwitching,
});
